export default __webpack_public_path__ + "c145002addc106b58dcb3f25a483771c.png";